import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
// Use consistent styling
import 'sanitize.css/sanitize.css';
import { HelmetProvider } from 'react-helmet-async';
import { configureAppStore } from 'store/configureStore';
import { App } from 'app';
import reportWebVitals from './reportWebVitals';

// Initialize languages
import './locales/i18n';
import ThemeProvider from 'context/themeContext';
import { syncSharedViewSessionFromSearch } from 'utils/sharedViewMode';

syncSharedViewSessionFromSearch(window.location.search);

const store = configureAppStore();
const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <ThemeProvider>
      <HelmetProvider>
        <React.Fragment>
          <App />
        </React.Fragment>
      </HelmetProvider>
    </ThemeProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
